// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from 'plugins/http'
import { getData } from 'utils/get'

// send login data and retrive a new token
export const postLogin = ({ email, password }) =>
  http.post('/auth/login', { email, password })
  /**
   * functional approach, more readable and generate minus code
   * examples:
   * PromiseObject.then(response => response.data)
   * PromiseObject.then({ data } => data)
   *
   * We do this many times in many locations.
   * We know that .then accepts a function and what arguments it receives
   * This is because in JavaScript functions are first class citizens.
   * In summary we can pass functions as arguments and also receive functions as results
   * (first-class function and higher-order function)
   */
  .then(getData) // .then(response => getData(response))



//register user
export const postRegister = (data) => http.post('/auth/register', data).then(getData) // .then(response => getData(response))

// verify
export const postVerification = ({ id, secret }) => http.post('/auth/verify', { id, secret }).then(getData)


// get current user's data
export const loadUserData = () => http.get('/me').then(getData).catch((e)=>{
  // pass
})

// revoke current token
export const revokeToken = () => http.post('/auth/token/revoke').then(getData).catch(e)

export const getUserForGoogleLogin = ({ token  }) =>
http.post('/gsuite/users/me', { token})
.then(getData).catch((e)=>{
  // pass
}) // .then(response => getData(response))

export const getUserForO365Login = ({ token  }) =>
http.post('/office/users/me', { token})
.then(getData) // .then(response => getData(response))

export const getUserForAD = ({ token  }) =>
http.post('/exchange/users/me', { token})
.then(getData) // .then(response => getData(response))

export const getUserForOutlookLogin = ({ token  }) =>
http.post('/users/me', { token})
.then(getData).catch((e)=>{
  // pass
})

export const sendForgotLink = ({ email  }) =>
http.post('auth/verify/mail', { email})
.then(getData).catch((e)=>{
  // pass
})

export const changeResetPassword = ({ token,password  }) =>
http.post('exchange/auth/reset/changepassword', { token,password})
.then(getData).catch((e)=>{
  // pass
})

// verify
export const attemptLoginVerification = ({ secret, token }) =>
    http.post('auth/verify', {  secret , token}).then(getData).catch((e)=>{
      // pass
      
    })

export const attempt2FASkipVerification = ({ status,email, token }) =>
    http.post('auth/userverifystatus', {  status,email , token}).then(getData).catch((e)=>{
      // pass
      
    })
    
export const recaptchaVerification = ({ recaptchaToken }) => http.post('auth/recaptchaverify', { recaptchaToken })

export const contactus = (data) => http.post('auth/contactus', data)



// WEBPACK FOOTER //
// ./src/app/auth/services.js